import script from "./Wrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./Wrapper.vue?vue&type=script&setup=true&lang=js"

import "./Wrapper.vue?vue&type=style&index=0&id=5097551a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5097551a"]])

export default __exports__